export enum OrderType {
    CDDoor = 0,
    Part = 1
}

export const OrderTypeMetadata = {
    '0' : {
        display: 'Complete Door',
        value: 0
    },
    '1': {
        display: 'Part',
        value: 1
    },
    '2': {
        display: 'Rolling Steel',
        value: 2
    }
}